module.exports = __webpack_public_path__ + "static/media/zocalos.0acd6108.jpg";